/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    headerContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
        },
    },
    title: {
        color: '#000000',
        fontSize: '2rem !important',
        textDecoration: 'none',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.5rem !important',
        },
        fontWeight: '700 !important',
        textAlign: 'center',
        letterSpacing: '0.01em',
        margin: '0 !important',
    }
}))

const PageTitle = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.headerContainer}>
            <h1 className={classes.title}>
                {props.title}
            </h1>
        </div>
    );
}

export default PageTitle;